var map = {
	"./air.png": "2ff7",
	"./biodiversity.png": "432e",
	"./climate.png": "7abf",
	"./contacts.png": "bdce",
	"./farming.png": "70f5",
	"./home.png": "6df0",
	"./land.png": "92e0",
	"./power-engineering.png": "7714",
	"./security.png": "e65b",
	"./transport.png": "473e",
	"./waste.png": "e0b9",
	"./water.png": "c9ba"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6dc9";